import React from "react";
import { Control } from "react-hook-form";
import { SelectProps } from "@RooUI";

import { ControlledSelect } from "../Controllers";
import { StateOption } from "../EditProfile/service";

import { useStates } from "./hooks/useStates";

interface ControlledStateSelectProps
  extends Omit<SelectProps<StateOption>, "onChange" | "value" | "options"> {
  control: Control<any>;
  name: string;
}

export const ControlledStateSelect = (props: ControlledStateSelectProps) => {
  const { stateOptions } = useStates();
  return (
    <ControlledSelect
      // @ts-expect-error TS2783
      name={props.name}
      // @ts-expect-error TS2783
      control={props.control}
      defaultValue={props.defaultValue}
      label="State"
      options={stateOptions}
      searchable
      placeholder={props.placeholder}
      additionalSearchFilterFields={["stateCode"]}
      error={props.error}
      {...props}
    />
  );
};
